import { CaretDoubleUpIcon as PhosphorCaretDoubleUpIcon } from "@phosphor-icons/react/dist/ssr/CaretDoubleUp";

import { createAppIcon } from "@/components/createAppIcon";

export const DoubleChevronUpIcon = /* @__PURE__ */ createAppIcon(PhosphorCaretDoubleUpIcon);
